<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const LeftIcon = getIcon("LeftIcon");
</script>

{#if typeof LeftIcon === 'string'}
	<img src={LeftIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof LeftIcon === 'function'}
	<svelte:component this={LeftIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
